module.exports = __webpack_public_path__ + "img/top-list-left1.13b53bb0.png";